import { render } from "./VictoryPointChart.vue?vue&type=template&id=34daded4&ts=true"
import script from "./VictoryPointChart.vue?vue&type=script&lang=ts"
export * from "./VictoryPointChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__